import { render, staticRenderFns } from "./BaseImageOption.vue?vue&type=template&id=56a3b936&scoped=true&"
import script from "./BaseImageOption.vue?vue&type=script&lang=ts&"
export * from "./BaseImageOption.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56a3b936",
  null
  
)

export default component.exports